import { create } from 'zustand';

export interface AppNotification {
  id: string;
  title: string;
  body?: string;
  at: number;
  read: boolean;
}

interface NotificationStore {
  items: AppNotification[];
  markAllRead: () => void;
}

/** Only the UI plumbing: nothing produces notifications yet. */
export const useNotifications = create<NotificationStore>((set) => ({
  items: [],
  markAllRead: () => set((state) => ({ items: state.items.map((item) => ({ ...item, read: true })) })),
}));

export const selectUnreadCount = (state: NotificationStore) => state.items.filter((item) => !item.read).length;
